import { CloseCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type { ButtonProps } from 'antd';
import './closeButton.css';

type CloseButtonProps = Omit<ButtonProps, 'children' | 'icon' | 'type' | 'size'> & {
  label?: string;
};

/** Compact close control for headers and inline dismiss actions. */
export default function CloseButton({ label = 'Close', className = '', ...props }: CloseButtonProps) {
  return (
    <Button
      {...props}
      type='text'
      size='small'
      aria-label={label}
      className={`dashboard-close-button ${className}`}
      icon={<CloseCircleOutlined />}
    />
  );
}
